// import { useState } from "react";
import {useNavigate, useOutletContext } from "react-router-dom";
// import BusCardSliderS1 from "../../golbal/sliders/busCardSliderS1";
// import PlansX4 from "../../golbal/sliders/plansX4";
// import api from "../../../utils/api";
// import HorizontalSlider from "../../golbal/sliders/horizontalSlider";
// import ColoredSpinner from "../../alret/spiners/coloredSpiner/coloredSpinner";
import tools from "../../../utils/tools";
// import renderData from "../../../utils/renderData";
import MetaDecorator from "../../../utils/metaDecorator";
import renderData from "../../../utils/renderData";
// import demyData from "../../../utils/demyData";

export default function DemyHomeEn() {
  const [pubData] = useOutletContext();
  // console.log("pubData", pubData);
  // const [data, setData] = useState({ center: "", program: "", level: "" });
  // console.log('demy home data' ,data);
  // const [popCat, setPopCat] = useState([]);
  // console.log("pubData", pubData);
  const navigate = useNavigate();
  const page = "demyHome";
  // const { lang, state:{state,stateShort,lat,lng}, country, countryShort } =
  // tools.getItemFromLocalStorage("initSetup", {});

  function navigateHandle(url, section) {
    window.scroll(0, 0);
    setTimeout(() => navigate(url), 200);
    const storedFilters = JSON.parse(localStorage.getItem("storedFilters"));
    if (storedFilters && storedFilters[section]) {
      delete storedFilters[section];
      localStorage.setItem("storedFilters", JSON.stringify(storedFilters));
    }
  }

  const { translations } =
    JSON.parse(localStorage?.getItem("countryDetails")) ?? {};
  const title = `Metademy | Metamarce Academy `;
  const description = `Access to expert and committed tutors around the world, 100% quality and price guarantee, payment by credit card and PayPal`;
  const structuredData = [
    // ...renderData.structuredData,
    {
      "@context": "http://schema.org",
      "@type": "WebPage",
      name:"Metademy" ,
      image: "https://www.metamarce.com/img/Metademy/demy-fp-en.jpg",
      url: window.location.href,
      breadcrumb: {
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            item: {
              "@id": "https://www.metamarce.com/",
              name: "landing",
              description: "A bridge between tutors and students around the world",
            },
          },
          {
            "@type": "ListItem",
            position: 2,
            item: {
              "@id": `https://www.metamarce.com/${window.lang}`,
              name: `Home`,
              description:
                "Metamarce academy is a bridge between tutors and students around the world",
            },
          },
          {
            "@type": "ListItem",
            position: 3,
            item: {
              "@id": `https://www.metamarce.com/${window.lang}/demy`,
              name: `Metademy `,
              description: "Tutors list",
            },
          },
        ],
      },
      // about: {
      //   "@type": "Place",
      //   name: state?.toUpperCase(),
      //   address: {
      //     "@type": "PostalAddress",
      //     // "addressLocality": "City",
      //     addressRegion: state?.toUpperCase(),
      //     // "postalCode": "Postal Code",
      //     addressCountry: country?.toUpperCase(),
      //   },
      //   geo: {
      //     "@type": "GeoCoordinates",
      //     latitude: lat, // Replace with the actual latitude
      //     longitude: lng, // Replace with the actual longitude
      //   },
      // },
    },
  ];

  const metaTagsData = {
    title,
    description,
    section: "metademy",
    url: `https://www.metamarce.com/${window.lang}/demy`,
    canonical: `https://www.metamarce.com/${window.lang}/demy`,
    img: "https://www.metamarce.com/img/Metademy/demy-fp-en.jpg",
    type: "webpage",
  };

  return (
    <div className="metademy-page metademy-page-en" dir="ltr">
      <MetaDecorator data={{ ...metaTagsData, structuredData }} />
      {/* <nav className="p-md-3 p-2 bg-beigeYellow" aria-label="breadcrumb">
  <ol className="breadcrumb">
    <li className="breadcrumb-item">
      <Link to={`/${window.lang}`}>
        خانه
      </Link>
    </li>
    <li className="breadcrumb-item">
      <strong> متادمی</strong>
    </li>
  </ol>
</nav> */}

      <div className="demy-fp mt-0 text-center w-100 display-none-md">
        <img
          className="w-100 max-w-m mx-auto px-5 pb-5 "
          src="/img/Metademy/demy-fp-en.jpg"
          alt="Metademy Desktop"
        />
      </div>
      <div className="demy-fp text-center w-100 display-tablet ">
        <img
          className="w-100 max-w-1000 mx-auto px-1 pb-5 "
          src="/img/Metademy/Metademy-mobile-green-red2-en.jpg"
          alt="Metademy Mobile"
        />
      </div>
      {/* sections */}
      <div className="text-center max-w-1000 mx-auto my-5">
        <div className="row px-3 py-md-5">
          <div className="col px-0 ">
            {" "}
            <img
              className="w-100 demy-cat "
              src="/img/Metademy/1e.jpg"
              onClick={(e) => navigateHandle("tutor/filters", "tutor")}
              alt="tutor/filters"
            />
          </div>
          <div className="col px-1 ">
            {" "}
            <img
              className="w-100 demy-cat "
              src="/img/Metademy/2e.jpg"
              onClick={(e) => navigateHandle(`tutor/home`, "tutorHome")}
              alt="tutor/Home"
            />
          </div>
          <div className="col px-0">
            {" "}
            <img
              className="w-100 demy-cat "
              src="/img/Metademy/3e.jpg"
              onClick={(e) => navigateHandle("center/home", "center")}
              alt="center/home"
            />
          </div>
        
        </div>
        {/* <div className="col px-0">
            {" "}
            <img
              className="w-100 demy-cat "
              src="https://img.freepik.com/free-photo/city-committed-education-collage-concept_23-2150062207.jpg?ga=GA1.1.1592690541.1727963591&semt=ais_hybrid"
              onClick={(e) => navigateHandle('/en/demy/center/home','center')}
              alt="center/filters"
            />
          </div> */}

        {/* <img className="demy-cat mx-3" src="/img/Metademy/2.png" alt="" />
          <img className="demy-cat mx-3" src="/img/Metademy/3.png" alt="" />
          <img className="demy-cat mx-3" src="/img/Metademy/4.png" alt="" /> */}
      </div>

      <div className="tutor-frame max-w-m  mx-auto my-7">
        <ul className="max-w-1000 mx-auto">
          <li className="row   banner-listing-2 w-100  ads-all mx-auto">
            <div className="col-md-4  d-flex align-items-center justify-content-center px-5  img-banner-2 ">
              <img
                className="w-100  rounded-2"
                src="/img/Metademy/67.jpg"
                // src="/img/Metademy/Metademy-students.png"
                alt="Are you a student"
              />
            </div>
            <div className="col-md-8 px-md-5  pb-5 titr7 titr7-25 d-flex  align-items-center justify-content-center text-gray-green ">
            Are you a student
            <br />
             facing challenges in your studies?

            </div>
          </li>
          <li className="row   banner-listing-2 w-100  ads-all mx-auto">
            <div className="col-md-4  order-md-2 d-flex align-items-center justify-content-center px-5  img-banner-2 ">
              <img
                className="w-100  rounded-2"
                src="/img/Metademy/156.jpg"
                // src="/img/Metademy/Metademy-students.png"
                alt="Are you a parent and need someone"
              />
            </div>
            <div className="col-md-8 px-md-5 pb-5 titr7 titr7-25 d-flex align-items-center justify-content-center text-gray-green">
            Are you a parent looking for someone 

              <br />
              to support your child's learning?
              </div>
          </li>
          <li className="row   banner-listing-2 w-100  ads-all mx-auto">
            <div className="col-md-4  d-flex align-items-center justify-content-center px-5  img-banner-2 ">
              <img
                className="w-100  rounded-2"
                src="/img/Metademy/152.jpg"
                // src="/img/Metademy/Metademy-students.png"
                alt="Do you want to master a new art or skill?"
              />
            </div>
            <div className="col-md-8 px-md-5  pb-5 titr7 titr7-25 d-flex  align-items-center justify-content-center text-gray-green">
            Do you want to master a new art or skill?
            </div>
          </li>
        </ul>

        <div className="px-md-5 py-md-5 p-3 max-w-m   rounded-5 bg-greenGray mx-3 my-5 ">
          <div className="text-center  w-100 titr7 titr7-25 text-beigeYellow  ">
          Metademy gives you the opportunity to choose from hundreds of top tutors worldwide and expand your knowledge and skills
          </div>
          {/* <div
              className="btn primary-btn  tutor-btn font-20 bg-greenGray"
              onClick={(e) =>
                navigateHandle(`/${window.lang}/demy/registertutor`)
              }
            >
              <i className="bi bi-file-text p-1 font-20">   راهنما و قوانین متادمی</i>
          
           

          
        </div> */}
        </div>
      </div>

      <div className="tutor-frame demy-fp  mx-auto my-7">
        <div className="row   banner-listing-2 w-100  ads-all mx-auto">
          <div className="col-md-7 img-banner-text-21 d-flex flex-column align-items-md-start align-items-center justify-content-end ">
            <ul className="mx-md-5 my-3 px-1 flex-column text-start text-green-dark align-items-start">
              <li className="titr1 text-pink-orange mb-4">Why Metademy?
              </li>
              <li className="my-2">
                <i className="bi bi-circle-fill fs-6 mx-2"></i>
                Access top professors from around the world
                </li>
              <li className="my-2">
                <i className="bi bi-circle-fill fs-6 mx-2"></i>
                Easily choose the right teacher using helpful filters
                </li>

              <li className="my-2">
                <i className="bi bi-circle-fill fs-6 mx-2"></i>
                Get a full refund if your class is not held
                </li>

              <li className="my-2">
                <i className="bi bi-circle-fill fs-6 mx-2"></i>
                Enjoy a free trial session to find the perfect match
                </li>
              <li className="my-2">
                <i className="bi bi-circle-fill fs-6 mx-2"></i>
                Take classes at any time, day or night
                </li>
              <li className="my-2">
                <i className="bi bi-circle-fill fs-6 mx-2"></i>
                Secure payments               <span className="font-12 ps-2 ">(through credit card or PayPal)</span>
              </li>
            </ul>
            <div
              className="btn primary-btn  tutor-btn2 w-75 mx-md-5 mx-0 my-5"
              onClick={(e) => navigateHandle(`tutor/filters`)}
            >
              <i className="bi bi-pencil-square p-1"></i>
              Find a tutor!
            </div>
            {/* <!-- </button> --> */}
          </div>
          <div className="col-md-5 img-banner-text-21 d-flex align-items-center justify-content-center p-5  img-banner-2 ">
            <img
              className="w-100  rounded-2"
              src="/img/Metademy/81.jpg"
              // src="/img/Metademy/Metademy-students.png"
              alt="Search for a teacher "
            />
          </div>
        </div>
      </div>

      {/* why metademy for tutors */}
      <div className="text-center max-w-1000 mx-auto my-5">
        <div className="titr1 text-pink-orange mb-4">
        How does Metademy work?
        </div>

        <div className="row px-3 py-md-5 g-3 ">
          <div className="col-md-3">
            <div className="card w-100">
              <img
                src="/img/Metademy/teacher.png"
                className="card-img-top w-25 mx-auto"
                alt="Choose a Teacher"
              />
              <div className="card-body">
                <h5 className="card-title titr5">1- Choose a teacher  </h5>
                <p className="card-text text-justify-metamarce">

                Use Metademy’s filters to find professors offering the course you need, and select the best match for your learning style.


                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3 ">
            <div className="card w-100">
              <img
                src="/img/Metademy/rescheduling.png"
                className="card-img-top w-25 mx-auto"
                alt=""
              />
              <div className="card-body">
                <h5 className="card-title titr5">
                  2- Select Your Time
                </h5>
                <p className="card-text text-justify-metamarce">
                Pick a free trial or class from the available time slots provided by the professor in the "Class Schedule."

                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card w-100">
              <img
                src="/img/Metademy/payment.png"
                className="card-img-top w-25 mx-auto"
                alt="3- payment
"
              />
              <div className="card-body">
                <h5 className="card-title titr5">3- Payment
</h5>
                <p className="card-text text-justify-metamarce">
                Securely pay for your classes via credit card or PayPal, with no concerns about payment methods or currency conversions.


                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card w-100">
              <img
                src="/img/Metademy/classroom.png"
                className="card-img-top w-25 mx-auto"
                alt=" 4- Participation in the class
"
              />
              <div className="card-body">
                <h5 className="card-title titr5">4- Attend the Class
                </h5>
                <p className="card-text text-justify-metamarce">
                Join the class at the scheduled time using the link sent by your professor.


                </p>
              </div>
            </div>
          </div>
        </div>
        <button
          className="btn primary-btn tutor-btn bg-pinkOrange  shadow-none mt-4"
          onClick={(e) => navigateHandle(`tutor/filters`)}
        >
          {" "}
          <i className="bi bi-pencil-square p-1"></i> Find a tutor!
        </button>
      </div>
      <div className="my-5  mx-auto ">
        <div className="row  tutor-frame banner-listing-2 w-100  max-w-m  mx-auto display-none-md">
          <img
            className="w-100 p-0 "
            src="/img/Metademy/Metademy-green-red-en-4.jpg"
            alt="Tutor"
          />
          {/* </div> */}
        </div>
        <div className="demy-fp text-center w-100 display-tablet ">
          <img
            className="w-100 max-w-1000 mx-auto p-0 "
            src="/img/Metademy/Metademy-mobile-green-red-en-4.jpg"
            alt="Metademy-mobile-green-red"
          />
        </div>
        <div className="row   banner-listing-2 w-100  max-w-m mx-auto ">
          <div className="col-md-5 img-banner-text-21-5 d-flex align-items-center justify-content-center p-0  img-banner-2 "></div>
          <div className="col-md-7 img-banner-text-21-5 d-flex flex-column align-items-md-start align-items-center p-0 justify-content-end ">
            <div
              className="btn primary-btn  tutor-btn2 w-75 mx-md-5 mx-0 mb-5 mt-0"
              onClick={(e) => navigateHandle(`tutor/filters`)}
            >
              <i className="bi bi-pencil-square p-1"></i>
            Find a tutor!
            </div>
            {/* <!-- </button> --> */}
          </div>
        </div>
      </div>
      <div className="my-5  mx-auto text-center">
        <div className="row  tutor-frame banner-listing-2 w-100  max-w-m  mx-auto display-none-md">
          {/* <div className="col img-banner-text-21 d-flex align-items-center justify-content-center p-lg-5 img-banner-2 "> */}
          <img
            className="w-100 p-0 "
            src="/img/Metademy/Metademy-green-red-en-2.jpg"
            alt="Metademy-green-red-en-2"
          />
          {/* </div> */}
        </div>
        <div className="demy-fp text-center w-100 display-tablet ">
          <img
            className="w-100 max-w-1000 mx-auto p-0 "
            src="/img/Metademy/Metademy-mobile-green-red-en-2.jpg"
            alt="Metademy-mobile-green-red-en-2"
          />
        </div>
        <button
          className="btn primary-btn tutor-btn bg-pinkOrange  shadow-none mt-4"
          onClick={(e) => navigateHandle(`tutor/home`)}
        >
          {" "}
          <i className="bi bi-pencil-square p-1"></i> How to become a tutor
        </button>
      </div>

      {/* <!-- *********************************** end of main ******************************************************************** --> */}

      {/* <!-- ***JavaScript*** --> */}

      {/* <div>
       
        <script
          src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js"
          integrity="sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM"
          crossOrigin="anonymous"
        ></script>

      
      </div> */}
    </div>
  );
}
